import styled from 'styled-components';
import Paper from '@material-ui/core/Paper';

export default styled(Paper)`
    &.stolo-cart-item {
        display: flex;
        flex-direction: column;
        padding: ${props => props.theme.space[8]};
        margin-right: ${props => props.theme.space[9]};
        margin-top: ${props => props.theme.space[9]};
        max-width: 22rem;
        flex-grow: 1;
        & .stolo-radio-checked {
          color: ${props => props.theme.palette.secondary[500]};
        }
    }
    
    & .stolo-radio-root {
        height: 2.4rem;
     }
    
    & .stolo-radio-label {
        ${props => props.theme.typography.label};
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        margin-left: 0;
        margin-right: 16px;
        display: flex;
        flex-direction: row;
     }
   
`;



// WEBPACK FOOTER //
// ./src/components/styles/AddToCartChildWrapper.js